// frontend/src/utils/timezone.js
import moment from 'moment-timezone';

// Configurazione del fuso orario italiano
moment.tz.setDefault('Europe/Rome');

// Funzioni di utilità per il fuso orario italiano
export const timezoneUtils = {
  // Ottenere l'ora attuale in Italia
  getItalianTime: () => moment().tz('Europe/Rome').valueOf(),
  
  // Ottenere l'ora di scadenza (in millisecondi)
  getExpirationTime: (minutes = 30) => moment().tz('Europe/Rome').add(minutes, 'minutes').valueOf(),
  
  // Formattare una data in ora italiana
  formatItalianDate: (date, format = 'DD/MM/YYYY HH:mm:ss') => {
    return moment(date).tz('Europe/Rome').format(format);
  },
  
  // Formattare una data per la visualizzazione (formato breve)
  formatItalianDateShort: (date) => {
    return moment(date).tz('Europe/Rome').format('DD/MM/YYYY');
  },
  
  // Formattare una data per la visualizzazione (formato lungo)
  formatItalianDateLong: (date) => {
    return moment(date).tz('Europe/Rome').format('dddd, DD MMMM YYYY, HH:mm');
  },
  
  // Verificare se una data è scaduta
  isExpired: (expirationTime) => {
    return moment().tz('Europe/Rome').valueOf() > expirationTime;
  },
  
  // Ottenere la data di oggi in formato ISO (per i confronti)
  getTodayISO: () => {
    return moment().tz('Europe/Rome').format('YYYY-MM-DD');
  },
  
  // Ottenere l'ora attuale in formato ISO
  getNowISO: () => {
    return moment().tz('Europe/Rome').toISOString();
  },
  
  // Convertire una data UTC in ora italiana
  fromUTC: (utcDate) => {
    return moment.utc(utcDate).tz('Europe/Rome');
  },
  
  // Convertire una data in UTC
  toUTC: (date) => {
    return moment(date).tz('Europe/Rome').utc();
  },
  
  // Ottenere il nome del fuso orario
  getTimezone: () => 'Europe/Rome',
  
  // Ottenere l'offset attuale (in minuti)
  getOffset: () => {
    return moment().tz('Europe/Rome').utcOffset();
  },
  
  // Verificare se è l'ora legale
  isDST: () => {
    const now = moment().tz('Europe/Rome');
    const jan = moment().tz('Europe/Rome').month(0);
    const jul = moment().tz('Europe/Rome').month(6);
    return now.utcOffset() !== jan.utcOffset();
  }
};

// Esportazione predefinita
export default timezoneUtils;


